import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const LanguageSwitcher: React.FC = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
    };

    return (
        <SwitcherContainer>
            <LanguageButton onClick={() => changeLanguage('en')} isActive={i18n.language === 'en'}>
                EN
            </LanguageButton>
            <LanguageButton onClick={() => changeLanguage('sv')} isActive={i18n.language === 'sv'}>
                SV
            </LanguageButton>
        </SwitcherContainer>
    );
};

const SwitcherContainer = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

const LanguageButton = styled.button<{ isActive: boolean }>`
    background: ${(props) =>
        props.isActive ? 'linear-gradient(116deg, #ed1e79, #9e005d)' : 'transparent'};
    color: ${(props) => (props.isActive ? 'white' : '#8b8b8b')};
    border: 2px solid ${(props) => (props.isActive ? 'white' : '#8b8b8b')};
    padding: 6px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.3s ease;

    &:hover {
        background: ${(props) =>
            props.isActive ? 'linear-gradient(116deg, #ed1e79, #9e005d)' : '#f5f5f5'};
        border-color: ${(props) => (props.isActive ? 'white' : '#8b8b8b')};
    }
`;

export default LanguageSwitcher;
